<template>
  <div>
    <section>
      <TippCard
        hintID="Terminplanung_Konfiguration_Allgemein_1_V1"
        text="Konfiguriere die Terminplanung für Deine Organisation an dieser Stelle."
      >
      </TippCard>
    </section>
    <section>
      <v-snackbar v-model="snackbar.model" timeout="3000">{{
        snackbar.text
      }}</v-snackbar>
    </section>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader icon="mdi-cog" title="Allgemein"></Subheader>
              <div class="mt-7">
                <v-card :loading="loading" :disabled="form1a.isLoading">
                  <v-card-text>
                    <v-form
                      v-model="form1a.isValid"
                      @submit.prevent="updateGeneralEventConfig"
                    >
                      Veranstaltungen
                      <v-container>
                        <v-row>
                          <event-deadline-config
                            :fristInMin.sync="
                              schedulingConfig.defaultDeadlineInMinutes
                            "
                          ></event-deadline-config>

                          <!-- <v-col cols="12">
                            <v-checkbox
                              label='Fehlende Rückmeldung nach Ablauf der Rückmeldefrist als "unentschuldigte" Teilnahme kennzeichnen'
                              hint="In der Anwesenheitsermittlung und Dienstverwaltung wird die fehlende Rückmeldung gesondert gekennzeichnet."
                              persistent-hint
                              disabled
                            >
                            </v-checkbox>
                          </v-col> -->
                          <v-col cols="12">
                            <v-checkbox
                              v-model="schedulingConfig.showAllEventsInList"
                              label="Anzeigen von allen Veranstaltungen der Organisation in Übersicht erlauben"
                              hint="Wenn diese Option deaktiviert ist, werden in der Übersicht nur Veranstaltungen angezeigt, die keine Tielnahmebeschränkung haben oder an denen der Benutzer teilnehmen darf. Über einen direkten Link zu den Veranstaltungsdetails kann die Veranstaltung weiterhin geteilt und aufgerufen werden."
                              persistent-hint
                            >
                            </v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          color="success"
                          :disabled="!form1a.isValid"
                          :loading="form1a.isLoading"
                          @click="updateGeneralEventConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card-text>

                  <v-divider></v-divider>
                  <v-card-text>
                    <v-form
                      v-model="form1b.isValid"
                      @submit.prevent="updateGeneralRequestConfig"
                    >
                      Abfragen
                      <v-container>
                        <v-row>
                          <event-deadline-config
                            :fristInMin.sync="
                              availabilityConfig.defaultDeadlineInMinutes
                            "
                          ></event-deadline-config>
                          <v-col cols="12">
                            <v-checkbox
                              v-model="availabilityConfig.showAllRequestsInList"
                              label="Anzeigen von allen Abfragen der Organisation in Übersicht erlauben"
                              hint="Wenn diese Option deaktiviert ist, werden in der Übersicht nur Abfragen angezeigt, die keine Tielnahmebeschränkung haben oder an denen der Benutzer teilnehmen darf. Über einen direkten Link zu den Abfragedetails kann die Veranstaltung weiterhin geteilt und aufgerufen werden."
                              persistent-hint
                            >
                            </v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          color="success"
                          :disabled="!form1b.isValid"
                          :loading="form1b.isLoading"
                          @click="updateGeneralRequestConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
            <v-col cols="12">
              <v-form
                v-model="positionCounterForm.isValid"
                @submit.prevent="updatePositionCountersConfig"
              >
                <Subheader
                  icon="mdi-tag"
                  title="Zähler für besetzbare Funktionen"
                ></Subheader>
                <div class="mt-7">
                  <v-card
                    :loading="loading"
                    :disabled="positionCounterForm.isLoading"
                  >
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-card outlined>
                              <v-card-text>
                                <div class="mb-2">
                                  Standardmäßig wird jede Person nur einmal
                                  erfasst. Sobald eine Besetzung oder Bedingung
                                  erfüllt ist, wird die Person bei nachfolgenden
                                  Zählern nicht erneut berücksichtigt. Diese
                                  Verhalten kann für einzelne Zähler deaktiviert
                                  werden, sodass Personen weiterhin in
                                  nachfolgenden Zählern gezählt werden.
                                </div>
                                <v-card
                                  v-for="(
                                    counter, index
                                  ) in schedulingConfig.positionCounters"
                                  :key="index"
                                  dense
                                  outlined
                                  class="my-2"
                                >
                                  <v-card-text class="pa-0">
                                    <v-container
                                      ><v-row dense>
                                        <v-col cols="6" md="2" sm="2">
                                          <v-checkbox
                                            v-model="
                                              counter.allowMultipleCounts
                                            "
                                            label="Mehrfachzählung zulassen"
                                            dense
                                            hide-details="auto"
                                            persistent-hint
                                          ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="2" sm="12">
                                          <v-text-field
                                            v-model.trim="counter.shortTitle"
                                            outlined
                                            dense
                                            label="Kurzbezeichnung"
                                            hide-details="auto"
                                          ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2" sm="12">
                                          <v-text-field
                                            v-model.trim="counter.title"
                                            outlined
                                            dense
                                            label="Bezeichnung"
                                            hide-details="auto"
                                          ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4" sm="6">
                                          <!-- todo -->
                                          <v-select
                                            v-model="counter.positions"
                                            :items="positions"
                                            outlined
                                            dense
                                            :rules="[rules.required]"
                                            hide-details="auto"
                                            label="Funktionen"
                                            item-text="title"
                                            item-value="meta.id"
                                            multiple
                                            chips
                                            small-chips
                                            deletable-chips
                                          ></v-select>
                                        </v-col>

                                        <v-col cols="12" md="2" sm="6">
                                          <v-btn
                                            depressed
                                            text
                                            color="error"
                                            @click="deleteCounter(counter)"
                                            ><v-icon left small
                                              >mdi-delete</v-icon
                                            >Löschen</v-btn
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                </v-card>
                                <v-btn
                                  color="success"
                                  depressed
                                  @click="addCounter()"
                                  ><v-icon left small>mdi-plus</v-icon
                                  >Hinzufügen</v-btn
                                >
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          color="success"
                          :disabled="!positionCounterForm.isValid"
                          :loading="positionCounterForm.isLoading"
                          @click="updatePositionCountersConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </div>
              </v-form>
            </v-col>

            <v-col cols="12">
              <v-form
                v-model="form2.isValid"
                @submit.prevent="updateTemplateConfig"
              >
                <Subheader
                  icon="mdi-notebook"
                  title="Auswahlvorlagen"
                ></Subheader>
                <div class="mt-7">
                  <v-card :loading="loading" :disabled="form2.isLoading">
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-combobox
                              v-model="schedulingConfig.ppeTemplates"
                              :items="
                                $store.state.organization.activeOrganization
                                  .config.scheduling.ppeTemplates
                              "
                              label="Vorlagen für Einsatzkleidung/PSA verwalten"
                              multiple
                              outlined
                              clearable
                              deletable-chips
                              auto-select-first
                              :search-input.sync="searchPPE"
                              hide-selected
                              small-chips
                              persistent-hint
                              hint="Diese Vorlagen werden bei der Erstellung von Veranstaltungen und Abgabe von Rückmeldungen zur Auswahl angeboten."
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Neuen Eintrag eingeben und mit
                                      <kbd>enter</kbd> bestätigen.
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template></v-combobox
                            >
                          </v-col>
                          <v-col cols="12">
                            <v-card outlined>
                              <v-card-text>
                                <div class="mb-2">Vorlagen für Aufgaben</div>
                                <v-card
                                  v-for="task in schedulingConfig.taskTemplates"
                                  :key="task.id"
                                  dense
                                  outlined
                                  class="my-2"
                                >
                                  <v-card-text class="pa-0">
                                    <v-container
                                      ><v-row>
                                        <v-col cols="12" md="5" sm="12">
                                          <v-text-field
                                            v-model.trim="task.icon"
                                            outlined
                                            dense
                                            label="Icon auswählen"
                                            placeholder="car"
                                            prefix="mdi-"
                                            hide-details="auto"
                                            hint="Optional: ID von Icon aus Material Design Icons Bibiliothek angeben"
                                            :prepend-inner-icon="`mdi-${task.icon}`"
                                            ><template v-slot:append-outer
                                              ><v-btn
                                                depressed
                                                small
                                                @click="openMdiIconLibrary"
                                                >Icons durchsuchen
                                                <v-icon right
                                                  >mdi-open-in-new</v-icon
                                                ></v-btn
                                              ></template
                                            ></v-text-field
                                          > </v-col
                                        ><v-col cols="12" md="5" sm="6">
                                          <v-text-field
                                            v-model.trim="task.title"
                                            outlined
                                            dense
                                            :rules="[rules.required]"
                                            hide-details="auto"
                                            label="Aufgabenbezeichnung"
                                          ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="2" sm="6">
                                          <v-btn
                                            depressed
                                            text
                                            color="error"
                                            @click="deleteTask(task)"
                                            ><v-icon left small
                                              >mdi-delete</v-icon
                                            >Löschen</v-btn
                                          >
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                </v-card>
                                <v-btn
                                  color="success"
                                  depressed
                                  @click="addTask()"
                                  ><v-icon left small>mdi-plus</v-icon
                                  >Hinzufügen</v-btn
                                >
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          color="success"
                          :disabled="!form2.isValid"
                          :loading="form2.isLoading"
                          @click="updateTemplateConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </div>
              </v-form>
            </v-col>

            <v-col cols="12">
              <v-form
                v-model="form3.isValid"
                @submit.prevent="updateCancellationNoticeConfig"
              >
                <Subheader
                  icon="mdi-run-fast"
                  title="Abwesenheiten von Veranstaltungen"
                ></Subheader>
                <div class="mt-7">
                  <v-card :loading="loading" :disabled="form3.isLoading">
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-checkbox
                              v-model="
                                schedulingConfig.cancellation.allowNotice
                              "
                              label="Begründete Abwesenheiten von Veranstaltungen erlauben"
                              hint="Nach Ablauf der Rückmeldefrist kann eine Abmeldung erfolgen, die gesondert gekennzeichnet und hervorgehoben wird."
                              persistent-hint
                            >
                            </v-checkbox>
                          </v-col>
                          <v-col
                            v-if="schedulingConfig.cancellation.allowNotice"
                            cols="12"
                          >
                            <v-checkbox
                              v-model="
                                schedulingConfig.cancellation
                                  .notifyEventOrganizers
                              "
                              disabled
                              label="Veranstaltungsorganisatoren benachrichtigen"
                            ></v-checkbox>
                          </v-col>

                          <v-col
                            cols="12"
                            v-if="schedulingConfig.cancellation.allowNotice"
                          >
                            <v-autocomplete
                              v-model="
                                schedulingConfig.cancellation.notifyPersons
                              "
                              :items="membershipsListFiltered"
                              :disabled="
                                !schedulingConfig.cancellation.allowNotice
                              "
                              chips
                              small-chips
                              outlined
                              deletable-chips
                              label="Zusätzlich zu benachrichtigende Personen"
                              item-text="displayName"
                              item-value="uid"
                              multiple
                              clearable
                              hide-details="auto"
                            >
                            </v-autocomplete>
                          </v-col>
                          <v-col
                            v-if="schedulingConfig.cancellation.allowNotice"
                            cols="12"
                          >
                            <notifications-forecast-preview-card
                              infoText="Es wird versucht, Organisatoren der Veranstaltung und berechtigte
          Personen zu benachrichtigen."
                              :notifyPersonsUids="
                                schedulingConfig.cancellation.notifyPersons
                              "
                              notificationTriggerId="scheduling_eventCancellationNoticeCreated"
                            ></notifications-forecast-preview-card>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- :disabled="!form3.isValid" -->
                        <v-btn
                          depressed
                          color="success"
                          :loading="form3.isLoading"
                          @click="updateCancellationNoticeConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </div>
              </v-form>
            </v-col>

            <v-col cols="12">
              <v-form
                v-model="form4.isValid"
                @submit.prevent="updateDutyReportReminderConfig"
              >
                <Subheader
                  icon="mdi-file-document-alert"
                  title="Erinnerungen bei fehlender Dokumentation"
                ></Subheader>
                <div class="mt-7">
                  <v-card :loading="loading" :disabled="form4.isLoading">
                    <v-card-text>
                      <v-alert type="info" text dense class="mb-4">
                        Ist für die Veranstaltungsart die Erinnerung aktiviert,
                        werden Personen benachrichtigt, wenn nach Abschluss der
                        Veranstaltung kein Dienstbericht innerhalb von 24
                        Stunden erstellt wurde.
                      </v-alert>

                      <v-container class="pa-0">
                        <v-row>
                          <!-- Step 1 -->
                          <v-col cols="12">
                            <v-card outlined class="notification-step">
                              <v-card-text class="d-flex align-start">
                                <v-avatar
                                  color="primary"
                                  size="36"
                                  class="mr-4 mt-1 flex-shrink-0"
                                >
                                  <span class="white--text text-h6">1</span>
                                </v-avatar>
                                <div>
                                  <div class="subtitle-1 font-weight-medium">
                                    Festgelegte Empfänger aus Veranstaltungsart
                                    + Organisatoren
                                  </div>
                                  <div class="body-2 grey--text text--darken-1">
                                    Nur Personen, die an der Veranstaltung
                                    teilgenommen haben (Rückmeldestatus
                                    "Verfügbar" oder "Wenn notwendig")
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <!-- Arrow -->
                          <v-col cols="12" class="text-center py-0">
                            <v-icon color="grey" size="28"
                              >mdi-arrow-down</v-icon
                            >
                            <div class="caption grey--text">
                              Falls keine Empfänger übrig bleiben
                            </div>
                          </v-col>

                          <!-- Step 2 -->
                          <v-col cols="12">
                            <v-card outlined class="notification-step">
                              <v-card-text class="d-flex align-start">
                                <v-avatar
                                  color="primary"
                                  size="36"
                                  class="mr-4 mt-1 flex-shrink-0"
                                >
                                  <span class="white--text text-h6">2</span>
                                </v-avatar>
                                <div>
                                  <div class="subtitle-1 font-weight-medium">
                                    Festgelegte Empfänger aus Veranstaltungsart
                                    + Organisatoren
                                  </div>
                                  <div class="body-2 grey--text text--darken-1">
                                    Alle konfigurierten Personen (ohne Filterung
                                    nach Teilnahme)
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <!-- Divider with OR -->
                          <v-col cols="12" class="text-center py-2">
                            <v-divider></v-divider>
                            <v-chip small class="my-2" outlined>
                              <v-icon left small>mdi-swap-vertical</v-icon>
                              Falls keine Personen in Veranstaltungsart
                              konfiguriert
                            </v-chip>
                            <v-divider></v-divider>
                          </v-col>

                          <!-- Step 3 -->
                          <v-col cols="12">
                            <v-card outlined class="notification-step">
                              <v-card-text class="d-flex align-start">
                                <v-avatar
                                  color="orange"
                                  size="36"
                                  class="mr-4 mt-1 flex-shrink-0"
                                >
                                  <span class="white--text text-h6">1</span>
                                </v-avatar>
                                <div>
                                  <div class="subtitle-1 font-weight-medium">
                                    Festgelegte Empfänger (siehe unten) +
                                    Organisatoren
                                  </div>
                                  <div class="body-2 grey--text text--darken-1">
                                    Nur Personen, die an der Veranstaltung
                                    teilgenommen haben
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <!-- Arrow -->
                          <v-col cols="12" class="text-center py-0">
                            <v-icon color="grey" size="28"
                              >mdi-arrow-down</v-icon
                            >
                            <div class="caption grey--text">
                              Falls keine Empfänger übrig bleiben
                            </div>
                          </v-col>

                          <!-- Step 4 -->
                          <v-col cols="12">
                            <v-card outlined class="notification-step">
                              <v-card-text class="d-flex align-start">
                                <v-avatar
                                  color="orange "
                                  size="36"
                                  class="mr-4 mt-1 flex-shrink-0"
                                >
                                  <span class="white--text text-h6">2</span>
                                </v-avatar>
                                <div>
                                  <div class="subtitle-1 font-weight-medium">
                                    Festgelegte Empfänger (siehe unten) +
                                    Organisatoren
                                  </div>
                                  <div class="body-2 grey--text text--darken-1">
                                    Alle konfigurierten Personen (ohne Filterung
                                    nach Teilnahme)
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <!-- Fallback config -->
                          <v-col cols="12" class="mt-4">
                            <v-autocomplete
                              v-model="
                                schedulingConfig.dutyReportReminder
                                  .defaultNotifyPersons
                              "
                              :items="membershipsListFiltered"
                              chips
                              small-chips
                              outlined
                              deletable-chips
                              label="Festgelegte Benachrichtigungsempfänger"
                              hint="Diese Personen werden benachrichtigt, wenn in der Veranstaltungsart keine spezifischen Empfänger konfiguriert sind."
                              persistent-hint
                              item-text="displayName"
                              item-value="uid"
                              multiple
                              clearable
                              hide-details="auto"
                            >
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          color="success"
                          :loading="form4.isLoading"
                          @click="updateDutyReportReminderConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import NotificationsForecastPreviewCard from "@/components/_systemwide/NotificationsForecastPreviewCard.vue";
import EventDeadlineConfig from "@/components/scheduling/EventDeadlineConfig.vue";
import { db } from "@/firebase";
import { SCHEDULING, ADMIN, AVAILABILITY } from "@/store/modules.js";
import {
  // GET_SCHEDULING_CONFIG,
  GET_USER_LIST,
  GET_USER_GROUPS,
  GET_POSITIONS,
  UPDATE_SCHEDULING_CONFIG,
  UPDATE_AVAILABILITY_CONFIG,
} from "@/store/action-types.js";

export default {
  name: "scheduling-config-tab-general",
  components: {
    TippCard,
    NotificationsForecastPreviewCard,
    Subheader,
    EventDeadlineConfig,
  },
  data() {
    return {
      searchPPE: "",
      loading: true,
      snackbar: {
        model: false,
        text: "",
      },
      form1a: {
        isValid: false,
        isLoading: false,
      },
      form1b: {
        isValid: false,
        isLoading: false,
      },
      form2: {
        isValid: false,
        isLoading: false,
      },
      form3: {
        isValid: false,
        isLoading: false,
      },
      form4: {
        isValid: false,
        isLoading: false,
      },
      positionCounterForm: {
        isValid: false,
        isLoading: false,
      },

      tasks: [],

      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
        min: (value) =>
          /^[+]?\d+([.]\d+)?$/.test(value) || "Muss positive Zahl sein.",
      },
    };
  },
  computed: {
    schedulingConfig() {
      const config =
        this.$store.state.organization.activeOrganization.config.scheduling;
      // Ensure dutyReportReminder has default values for backward compatibility
      if (!config.dutyReportReminder) {
        config.dutyReportReminder = {
          defaultNotifyPersons: [],
        };
      }
      return config;
    },
    availabilityConfig() {
      return this.$store.state.organization.activeOrganization.config
        .availability;
    },
    userGroups() {
      const userGroups = this.$store.state.admin.userGroups.map((obj) => ({
        title: obj.title,
        id: obj.meta.id,
      }));

      return userGroups;
    },
    memberships() {
      return this.$store.state.admin.membershipsPublic;
    },
    membershipsListFiltered() {
      const input = this.memberships;
      const groupItems = (arr) => {
        return arr.reduce((a, c) => {
          if (typeof a[c.group.title] === "undefined") a[c.group.title] = [];
          a[c.group.title] = [...a[c.group.title], c];
          return a;
        }, {});
      };
      const step1 = groupItems(input);
      const insertHeaders = (obj) => {
        return Object.entries(obj).reduce((a, [key, vals], i, d) => {
          let r = [
            {
              header: key,
            },
            ...vals,
          ];
          // this is needed to have the exact same array
          // that you presented as desirable output:
          // no divider at the last place
          if (i < d.length - 1) {
            r = [
              ...r,
              {
                divider: true,
              },
            ];
          }
          a = [...a, ...r];
          return a;
        }, []);
      };
      const step2 = insertHeaders(step1);
      const step3 = step2
        .filter(
          // FIXME: temporary fix, to be watched
          (item) =>
            item.header ||
            (item.user && item.user.displayName && item.user.uid),
        )
        .map((item) => {
          if (item.header) {
            // Skip headers and dividers
            return item;
          } else if (item.user && item.user.displayName && item.user.uid) {
            // Extract displayName and uid from membership object
            return {
              displayName: item.user.displayName || "",
              uid: item.user.uid,
            };
          } else {
            return {
              displayName: "",
              uid: "",
            };
          }
        });

      return step3;
    },
    positions() {
      return this.$store.state.availability.positions;
    },
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store
        .dispatch(`${ADMIN}${GET_USER_LIST}`, {
          organizationId: this.$route.params.organizationId,
          queryIsFiltered: true,
          query: {
            type: "active",
          },
        })
        .then(() => {
          return this.$store.dispatch(`${ADMIN}${GET_USER_GROUPS}`, {
            organizationId: this.$route.params.organizationId,
          });
        })
        .then(() => {
          return this.$store.dispatch(`${AVAILABILITY}${GET_POSITIONS}`, {
            organizationId: this.$route.params.organizationId,
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    openMdiIconLibrary() {
      var res = confirm(
        "Hinweis: Mit dem Öffnen der MDI Icon Library verlässt Du Mira One und wirst auf eine externe Internetseite weitergeleitet. Für die Inhalte können wir keine Haftung übernehmen.\n\nSuche nach einem passenden Icon und kopiere den Namen des Icons in das Eingabefeld.",
      );
      if (res == true) {
        window.open("https://materialdesignicons.com/", "_blank");
      }
    },
    addTask() {
      const taskId = db
        .collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("eventTasks")
        .doc().id;
      this.schedulingConfig.taskTemplates.push({
        title: "",
        icon: "",
        id: taskId,
      });
    },
    deleteTask(task) {
      this.schedulingConfig.taskTemplates.splice(
        this.schedulingConfig.taskTemplates.indexOf(task),
        1,
      );
    },
    deleteCounter(counter) {
      this.schedulingConfig.positionCounters.splice(
        this.schedulingConfig.positionCounters.indexOf(counter),
        1,
      );
    },
    addCounter() {
      const counterId = db
        .collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("positionCounters")
        .doc().id;
      this.schedulingConfig.positionCounters.push({
        allowMultipleCounts: false,
        title: "",
        shortTitle: "",
        positions: [],
        id: counterId,
      });
    },
    updatePositionCountersConfig() {
      if (this.positionCounterForm.isValid) {
        this.positionCounterForm.isLoading = true;
        this.$store
          .dispatch(`${SCHEDULING}${UPDATE_SCHEDULING_CONFIG}`, {
            organizationId: this.$route.params.organizationId,
            type: "onlyPositionCountersConfig",
            positionCounters: this.schedulingConfig.positionCounters,
          })
          .then(() => {
            this.positionCounterForm.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
          })
          .catch((error) => {
            console.log(error);
            this.positionCounterForm.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = error.message;
          });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },

    updateGeneralEventConfig() {
      if (this.form1a.isValid) {
        this.form1a.isLoading = true;
        console.log(
          this.schedulingConfig.defaultDeadlineInMinutes,
          this.schedulingConfig.showAllEventsInList,
        );
        this.$store
          .dispatch(`${SCHEDULING}${UPDATE_SCHEDULING_CONFIG}`, {
            organizationId: this.$route.params.organizationId,
            type: "onlyGeneralConfig",
            defaultDeadlineInMinutes:
              this.schedulingConfig.defaultDeadlineInMinutes,
            showAllEventsInList: this.schedulingConfig.showAllEventsInList,
          })
          .then(() => {
            this.form1a.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
          })
          .catch((error) => {
            console.log(error);
            this.form1a.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = error.message;
          });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
    updateGeneralRequestConfig() {
      if (this.form1.isValid) {
        this.form1.isLoading = true;
        this.$store
          .dispatch(`${AVAILABILITY}${UPDATE_AVAILABILITY_CONFIG}`, {
            organizationId: this.$route.params.organizationId,

            type: "onlyGeneralConfig",
            defaultDeadlineInMinutes:
              this.availabilityConfig.defaultDeadlineInMinutes,
            showAllRequestsInList:
              this.availabilityConfig.showAllRequestsInList,
          })
          .then(() => {
            this.form1.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
          })
          .catch((error) => {
            console.log(error);
            this.form1.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = error.message;
          });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
    updateTemplateConfig() {
      if (this.form2.isValid) {
        this.form2.isLoading = true;
        this.$store
          .dispatch(`${SCHEDULING}${UPDATE_SCHEDULING_CONFIG}`, {
            organizationId: this.$route.params.organizationId,
            type: "onlyTemplateConfig",
            ppeTemplates: this.schedulingConfig.ppeTemplates,
            taskTemplates: this.schedulingConfig.taskTemplates,
          })
          .then(() => {
            this.form2.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
          })
          .catch((error) => {
            console.log(error);
            this.form2.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = error.message;
          });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
    updateCancellationNoticeConfig() {
      if (this.form3.isValid) {
        this.form3.isLoading = true;
        this.$store
          .dispatch(`${SCHEDULING}${UPDATE_SCHEDULING_CONFIG}`, {
            organizationId: this.$route.params.organizationId,
            type: "onlyCancellationConfig",
            cancellation: this.schedulingConfig.cancellation,
          })
          .then(() => {
            this.form3.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
          })
          .catch((error) => {
            console.log(error);
            this.form3.isLoading = false;
            this.snackbar.model = true;
            this.snackbar.text = error.message;
          });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
    updateDutyReportReminderConfig() {
      this.form4.isLoading = true;
      this.$store
        .dispatch(`${SCHEDULING}${UPDATE_SCHEDULING_CONFIG}`, {
          organizationId: this.$route.params.organizationId,
          type: "onlyDutyReportReminderConfig",
          dutyReportReminder: this.schedulingConfig.dutyReportReminder,
        })
        .then(() => {
          this.form4.isLoading = false;
          this.snackbar.model = true;
          this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
        })
        .catch((error) => {
          console.log(error);
          this.form4.isLoading = false;
          this.snackbar.model = true;
          this.snackbar.text = error.message;
        });
    },
  },
};
</script>
